module.exports = __webpack_public_path__ + "img/headers-and-pagenumbers.0d6fc703.jpg";